// Mock data & helpers for CINEURASA landing page (FRONTEND-ONLY, NO BACKEND YET)

export const WHATSAPP_NUMBER = "628111621389"; // dummy number, replace later
export const WA_BASE_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const mockProducts = [
  {
    id: "cineurasa-bumbu-aceh",
    brand: "Cineurasa",
    name: "Bumbu Aceh Serbaguna",
    shortDescription:
      "Bumbu siap pakai khas Aceh dengan racikan rempah autentik untuk berbagai olahan favorit.",
    longDescription:
      "Cineurasa Bumbu Aceh Serbaguna diracik dari rempah pilihan khas Aceh untuk menghasilkan cita rasa gurih, pedas, dan aromatik. Praktis digunakan untuk berbagai menu khas Aceh tanpa ribet meracik bumbu dari nol.",
    imageUrl: "/assets/img/produk/10.jpeg",

    highlights: [
      "Racikan rempah khas Aceh",
      "Praktis & siap pakai",
      "Tanpa pengawet buatan",
      "Cocok untuk berbagai menu",
    ],

    generalInfo: {
      spiceLevel: "Sedang – Pedas",
      prepTime: "10–20 menit",
      servingSuggestion: "2–4 porsi",
    },

    variants: [
      {
        id: "nasi-goreng-aceh",
        name: "Nasi Goreng Aceh",
        description:
          "Nasi goreng khas Aceh dengan aroma rempah kuat, gurih, dan pedas yang menggugah selera.",
        imageUrl: "/assets/img/produk/nasi-goren-aceh.jpeg",
        spiceLevel: "Sedang – Pedas",
        cookTime: "10 menit",
        suitableFor: ["Sarapan", "Makan Siang", "Makan Malam"],
        tips: "Tambahkan telur dan acar bawang agar rasa makin autentik.",
      },

      {
        id: "mie-goreng-aceh",
        name: "Mie Goreng Aceh",
        description:
          "Mie goreng khas Aceh dengan rasa gurih rempah dan pedas seimbang seperti di warung Aceh favorit.",
        imageUrl: "/assets/img/produk/cineurasa.jpeg",
        spiceLevel: "Sedang",
        cookTime: "10–15 menit",
        suitableFor: ["Makan Siang", "Makan Malam"],
        tips: "Gunakan mie kuning atau mie telur untuk hasil terbaik.",
      },

      {
        id: "mie-bangladesh",
        name: "Mie Bangladesh",
        description:
          "Mie kuah khas Aceh dengan cita rasa rempah yang kuat, kuah kental, dan aroma menggoda.",
        imageUrl: "/assets/img/produk/mie-bangladesh.jpeg",
        spiceLevel: "Sedang – Pedas",
        cookTime: "15–20 menit",
        suitableFor: ["Makan Siang", "Makan Malam"],
        tips: "Tambahkan kol, tomat, dan telur agar lebih kaya rasa.",
      },
    ],
  },
];

export const mockBenefits = [
  {
    id: "praktis",
    icon: "Clock",
    title: "Praktis Tinggal Masak",
    description:
      "Tanpa ulek bumbu, tanpa repot belanja rempah. Buka kemasan, masak, selesai.",
  },
  {
    id: "rasa-restoran",
    icon: "Star",
    title: "Rasa Restoran di Rumah",
    description:
      "Racikan chef dengan standar rasa restoran, tapi tetap hangat ala rumahan.",
  },
  {
    id: "otentik",
    icon: "Flame",
    title: "Otentik Khas Aceh",
    description:
      "Rempah pilihan dengan karakter kuat khas Aceh, bukan bumbu instan pasaran.",
  },
  {
    id: "halal",
    icon: "Leaf",
    title: "Halal & Higienis",
    description:
      "Diproses dengan standar kebersihan dan bahan yang terjamin kehalalannya.",
  },
];
export const mockTestimonials = [
  {
    id: "testi-1",
    name: "Rina",
    imageUrl: "/assets/img/testimoni/1.jpeg",
  },
  {
    id: "testi-2",
    name: "Dimas",
    imageUrl: "/assets/img/testimoni/2.jpeg",
  },
  {
    id: "testi-3",
    name: "Nadia",
    imageUrl: "/assets/img/testimoni/3.jpeg",
  },
  {
    id: "testi-4",
    name: "Andi",
    imageUrl: "/assets/img/testimoni/4.jpeg",
  },
  {
    id: "testi-5",
    name: "Sari",
    imageUrl: "/assets/img/testimoni/5.jpeg",
  },
  {
    id: "testi-6",
    name: "Budi",
    imageUrl: "/assets/img/testimoni/6.jpeg",
  },
  {
    id: "testi-7",
    name: "Lina",
    imageUrl: "/assets/img/testimoni/7.jpeg",
  },
  {
    id: "testi-8",
    name: "Fajar",
    imageUrl: "/assets/img/testimoni/8.jpeg",
  },
  {
    id: "testi-9",
    name: "Maya",
    imageUrl: "/assets/img/testimoni/9.jpeg",
  },
  {
    id: "testi-10",
    name: "Rizky",
    imageUrl: "/assets/img/testimoni/10.jpeg",
  },
  {
    id: "testi-11",
    name: "Ayu",
    imageUrl: "/assets/img/testimoni/11.jpeg",
  },
];

export function buildWhatsAppMessage({ name, phone, location, paket, notes }) {
  const lines = [
    "Halo CINEURASA, saya mau pesan bumbu masak Aceh.",
    "",
    name ? `Nama: ${name}` : null,
    phone ? `No. WhatsApp: ${phone}` : null,
    location ? `Lokasi: ${location}` : null,
    paket ? `Pilihan paket: ${paket}` : null,
    notes ? `Catatan tambahan: ${notes}` : null,
  ].filter(Boolean);

  return lines.join("\n");
}

export function buildWhatsAppLink(payload) {
  const text = buildWhatsAppMessage(payload);
  return `${WA_BASE_URL}?text=${encodeURIComponent(text)}`;
}
export const productShowcase = [
  {
    id: "nasi-goreng-aceh",
    title: "Nasi Goreng Aceh",
    caption: "Aroma rempah kuat, pedas gurih, bikin nagih.",
    image: "/assets/img/produk/nasi-goren-aceh.jpeg",
  },
  {
    id: "mie-goreng-aceh",
    title: "Mie Goreng Aceh",
    caption: "Rasa warung Aceh favorit, tinggal tumis.",
    image: "/assets/img/produk/cineurasa.jpeg",
  },
  {
    id: "mie-bangladesh",
    title: "Mie Bangladesh",
    caption: "Kuah kental kaya rempah, hangat dan mantap.",
    image: "/assets/img/produk/mie-bangladesh.jpeg",
  },
];
export const mockGallery = [
  {
    id: "gallery-1",
    title: "Workshop Masak Menu Aceh",
    category: "Workshop",
    location: "Bandung",
    date: "2024-08-12",
    description:
      "Sesi workshop memasak menu khas Aceh menggunakan bumbu CINEURASA bersama peserta umum.",
    images: [
      {
        id: "g1-img-1",
        src: "/assets/img/gallery/workshop-1.jpeg",
        alt: "Workshop memasak menu Aceh bersama Cineurasa",
      },
      {
        id: "g1-img-2",
        src: "/assets/img/gallery/workshop-2.jpeg",
        alt: "Peserta mencoba bumbu Cineurasa saat workshop",
      },
      {
        id: "g1-img-3",
        src: "/assets/img/gallery/workshop-3.jpeg",
        alt: "Hasil masakan menu Aceh dari workshop Cineurasa",
      },
      {
        id: "g1-img-4",
        src: "/assets/img/gallery/workshop-4.jpeg",
        alt: "Hasil masakan menu Aceh dari workshop Cineurasa",
      },
    ],
  },

  {
    id: "gallery-2",
    title: "Bazar Kuliner Nusantara",
    category: "Bazar",
    location: "Jakarta",
    date: "2024-09-03",
    description:
      "Partisipasi Cineurasa dalam bazar kuliner nusantara dengan demo masak langsung.",
    images: [
      {
        id: "g2-img-1",
        src: "/assets/img/gallery/bazar-1.jpeg",
        alt: "Stand Cineurasa di bazar kuliner Jakarta",
      },
      {
        id: "g2-img-2",
        src: "/assets/img/gallery/bazar-2.jpeg",
        alt: "Pengunjung mencoba menu olahan Cineurasa",
      },
      {
        id: "g2-img-3",
        src: "/assets/img/gallery/bazar-3.jpeg",
        alt: "Pengunjung mencoba menu olahan Cineurasa",
      },
      {
        id: "g2-img-4",
        src: "/assets/img/gallery/bazar-4.jpeg",
        alt: "Aktivitas demo masak Cineurasa di bazar",
      },
      {
        id: "g2-img-5",
        src: "/assets/img/gallery/bazar-5.jpeg",
        alt: "Aktivitas demo masak Cineurasa di bazar",
      },
      {
        id: "g2-img-6",
        src: "/assets/img/gallery/bazar-6.jpeg",
        alt: "Aktivitas demo masak Cineurasa di bazar",
      },
      {
        id: "g2-img-7",
        src: "/assets/img/gallery/bazar-7.jpeg",
        alt: "Aktivitas demo masak Cineurasa di bazar",
      },
    ],
  },

  {
    id: "gallery-3",
    title: "Kolaborasi Komunitas UMKM",
    category: "Event",
    location: "Bogor",
    date: "2024-10-15",
    description:
      "Kolaborasi Cineurasa bersama komunitas UMKM lokal untuk edukasi bumbu siap masak.",
    images: [
      {
        id: "g3-img-1",
        src: "/assets/img/gallery/umkm-cineurasa (1).jpeg",
        alt: "Cineurasa berkolaborasi dengan komunitas UMKM",
      },
      {
        id: "g3-img-2",
        src: "/assets/img/gallery/umkm-cineurasa (2).jpeg",
        alt: "Sesi diskusi dan edukasi produk Cineurasa",
      },
      {
        id: "g3-img-3",
        src: "/assets/img/gallery/umkm-cineurasa (3).jpeg",
        alt: "Foto bersama peserta event Cineurasa",
      },
      {
        id: "g3-img-4",
        src: "/assets/img/gallery/umkm-cineurasa (4).jpeg",
        alt: "Foto bersama peserta event Cineurasa",
      },
      {
        id: "g3-img-5",
        src: "/assets/img/gallery/umkm-cineurasa (5).jpeg",
        alt: "Foto bersama peserta event Cineurasa",
      },
    ],
  },
];
